export default {
      id: "right-arrow-usage",
      viewBox: "0 0 13 23",
      url: __webpack_public_path__ + "img/icons.159f8dce.svg#right-arrow",
      toString: function () {
        return this.url;
      }
    }